import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import api, { apiError } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";
import { PageLoader } from "@/components/common/Loading";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setError("Missing token"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("error"); setError(apiError(e)); });
  }, [token]);

  return (
    <AuthLayout title="Email verification">
      {state === "loading" && <PageLoader label="Verifying" />}
      {state === "ok" && (
        <div className="flex flex-col items-center text-center py-4" data-testid="verify-ok">
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mb-3" />
          <p className="text-sm text-slate-600">Your email has been verified.</p>
          <Link to="/login" className="mt-6 text-sm text-[#0093D6] font-medium hover:underline">Continue to sign in</Link>
        </div>
      )}
      {state === "error" && (
        <div className="flex flex-col items-center text-center py-4" data-testid="verify-error">
          <XCircle className="w-12 h-12 text-rose-500 mb-3" />
          <p className="text-sm text-slate-600">{error}</p>
          <Link to="/login" className="mt-6 text-sm text-[#0093D6] font-medium hover:underline">Back to sign in</Link>
        </div>
      )}
    </AuthLayout>
  );
}
